// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1cXH9","header":"PatientQuestionnaire_header__1pD4o","info":"PatientQuestionnaire_info__3LI7d"};